export const ACTIONS_HISTORY_CHUNK = 'ActionsHistory';
